<template>
  <div class="kol-detail-page">
    <section class="detail-header">
      <div class="detail-title-main">
        <div class="detail-title-tools">
          <el-button class="back-link" type="text" icon="el-icon-arrow-left" @click="backList">返回列表</el-button>
          <span class="detail-kicker">签约管理</span>
        </div>
        <h1>{{ displayValue(dataForm.nickname) }}</h1>
        <p>{{ detailSummary }}</p>
      </div>
      <div class="detail-header-side">
        <div class="detail-status-card">
          <span>签约状态</span>
          <strong>{{ statusText() }}</strong>
          <el-tag v-if="deadlineTagText" :type="deadlineTagType" effect="plain" size="small">
            {{ deadlineTagText }}
          </el-tag>
        </div>
      </div>
    </section>

    <main class="detail-main">
      <el-tabs v-model="activeTab" class="detail-tabs">
        <el-tab-pane label="基础信息" name="base">
          <el-card class="detail-card base-detail-card" shadow="never">
            <div slot="header" class="detail-panel-header">
              <div>
                <h2>基础信息</h2>
                <p>查看和维护红人身份、签约信息和签约前平台资料</p>
              </div>
              <el-button
                v-if="canEditSignInfo && !baseEditable"
                type="text"
                icon="el-icon-edit"
                @click="enableTabEdit('base')">
                编辑
              </el-button>
            </div>
            <el-form
              ref="refForm"
              class="detail-form"
              :disabled="!baseEditable"
              :model="dataForm"
              :rules="rules"
              label-position="top"
              size="mini">
              <el-row :gutter="32" class="base-detail-layout-row">
                <el-col :span="16" class="base-detail-left">
                  <section class="form-section">
                    <h3>身份资料</h3>
                    <el-row :gutter="16" class="detail-info-grid">
                      <el-col :span="12">
                        <el-form-item label="红人昵称" prop="nickname">
                          <el-input v-model="dataForm.nickname" placeholder="红人昵称" />
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="红人姓名" prop="real_name">
                          <el-input v-model="dataForm.real_name" placeholder="红人姓名" />
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="身份证号" prop="id_card">
                          <el-input
                            v-if="baseEditable"
                            v-model="dataForm.id_card"
                            placeholder="身份证号" />
                          <el-input
                            v-else-if="canViewIdCard"
                            :value="displayValue(dataForm.id_card)"
                            placeholder="身份证号"
                            disabled />
                          <el-input
                            v-else
                            value="***"
                            placeholder="身份证号"
                            disabled />
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="手机号" prop="tel">
                          <el-input v-model="dataForm.tel" placeholder="手机号" />
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="微信号">
                          <el-input v-model="dataForm.wechat" placeholder="-" />
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="常用地址" prop="address">
                          <el-input v-model="dataForm.address" placeholder="常用地址" />
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </section>

                  <section class="form-section sign-section">
                    <h3>签约信息</h3>
                    <el-row :gutter="16" class="detail-sign-grid">
                      <el-col :span="12">
                        <el-form-item label="签约人" prop="signatory">
                          <SignatoryQuery
                            v-model="dataForm.signatory"
                            :name="dataForm.signatory"
                            :showSet="baseEditable" />
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="账号来源" prop="account_source">
                          <AccountSourceSelect v-model="dataForm.account_source" placeholder="账号来源" />
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="签约类型" prop="sign_type">
                          <el-select v-model="dataForm.sign_type" placeholder="选择签约类型" clearable>
                            <el-option
                              v-for="(item, value) in MapSignType"
                              :key="value"
                              :label="item.label"
                              :value="value" />
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="签约日期" prop="sign_date">
                          <el-date-picker
                            v-model="dataForm.sign_date"
                            type="date"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            placeholder="选择签约日期"
                            @change="changeSignDate" />
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="签约年份">
                          <el-input v-model="dataForm.year" placeholder="签约年份" disabled />
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="签约月份">
                          <el-input v-model="dataForm.month" placeholder="签约月份" disabled />
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="签约后主平台" prop="platform_code_aft">
                          <el-select v-model="dataForm.platform_code_aft" placeholder="选择签约主平台" clearable>
                            <el-option
                              v-for="item in platformOptions"
                              :key="item.code"
                              :label="item.name"
                              :value="item.code" />
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="合约性质" prop="nature">
                          <el-select v-model="dataForm.nature" placeholder="选择合约类型" clearable>
                            <el-option label="全约" :value="1" />
                            <el-option label="商务约" :value="2" />
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="合约年限" prop="term">
                          <el-input
                            v-model="dataForm.term"
                            placeholder="输入合约年限"
                            clearable
                            oninput="value=value.replace(/[^\d^\.^\-]/g,'')" />
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="续约年限">
                          <el-input
                            v-model="dataForm.renewal_years"
                            placeholder="输入续约年限"
                            clearable
                            oninput="value=value.replace(/[^\d^\.^\-]/g,'')" />
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="续约条件（万）" prop="renewal_cond">
                          <el-input
                            v-model="dataForm.renewal_cond"
                            placeholder="输入续约条件（万）"
                            clearable
                            oninput="value=value.replace(/[^\d^\.^\-]/g,'')" />
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="博主分成比例">
                          <el-input
                            v-if="baseEditable"
                            v-model="dataForm.blogger_ratio"
                            placeholder="输入博主分成比例"
                            clearable
                            oninput="value=value.replace(/[^\d^\.^\-]/g,'')">
                            <template slot="append">%</template>
                          </el-input>
                          <el-input
                            v-else-if="canViewRatio"
                            :value="displayValue(dataForm.blogger_ratio)"
                            placeholder="输入博主分成比例"
                            disabled>
                            <template slot="append">%</template>
                          </el-input>
                          <el-input
                            v-else
                            value="***"
                            placeholder="输入博主分成比例"
                            disabled>
                            <template slot="append">%</template>
                          </el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="合同编号">
                          <el-input
                            v-model="dataForm.contract_no"
                            placeholder="输入合同编号"
                            maxlength="100"
                            clearable />
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="分配组别">
                          <el-input :value="displayValue(dataForm.group_name)" disabled />
                        </el-form-item>
                      </el-col>
                      <el-col :span="24">
                        <el-form-item label="备注">
                          <el-input
                            v-if="baseEditable"
                            v-model="dataForm.remark"
                            type="textarea"
                            :rows="4"
                            maxlength="255"
                            show-word-limit
                            placeholder="备注" />
                          <el-input
                            v-else-if="canViewRemark"
                            :value="displayValue(dataForm.remark)"
                            type="textarea"
                            :rows="4"
                            placeholder="备注"
                            disabled />
                          <el-input
                            v-else
                            value="***"
                            type="textarea"
                            :rows="4"
                            placeholder="备注"
                            disabled />
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </section>
                </el-col>

                <el-col :span="8" class="base-detail-right">
                  <section class="form-section platform-section">
                    <h3>签约前平台</h3>
                    <BefPlatformInfo
                      :data="dataForm.sign_bef_info || []"
                      :edit="baseEditable"
                      @currentInfo="getBefPlatformInfo" />
                  </section>
                </el-col>
              </el-row>
            </el-form>

            <div class="detail-actions" v-if="canEditSignInfo && baseEditable">
              <el-button
                type="primary"
                :disabled="loadingSubmit"
                :loading="loadingSubmit"
                @click="saveTab('base')">
                保存
              </el-button>
            </div>
          </el-card>
        </el-tab-pane>

        <el-tab-pane label="签约记录" name="records">
          <el-card class="detail-card tab-panel-card" shadow="never">
            <div slot="header" class="detail-panel-header">
              <div>
                <h2>签约记录</h2>
                <p>维护历史签约、续约和合同信息</p>
              </div>
              <div class="tab-panel-actions">
                <el-button
                  v-if="canEditSignInfo && !recordsEditable"
                  type="text"
                  icon="el-icon-edit"
                  @click="enableTabEdit('records')">
                  编辑
                </el-button>
                <el-button
                  v-if="recordsEditable"
                  type="text"
                  icon="el-icon-plus"
                  @click="openSignRecordDialog">
                  新增记录
                </el-button>
              </div>
            </div>
            <div class="tab-panel-surface">
              <SignRecordTable
                v-if="id"
                ref="signRecordTable"
                detail-mode
                :artist-id="id"
                :can-view-ratio="canViewRatio"
                :is-edit="recordsEditable" />
            </div>
          </el-card>
        </el-tab-pane>

        <el-tab-pane label="结算信息" name="settle">
          <el-card
            v-if="id && userPermissions.indexOf('sign_settle') > -1"
            class="detail-card tab-panel-card"
            shadow="never">
            <div slot="header" class="detail-panel-header">
              <div>
                <h2>结算信息</h2>
                <p>维护红人结算方式和结算配置</p>
              </div>
              <div class="tab-panel-actions">
                <el-button
                  v-if="canEditSignInfo && !settleEditable"
                  type="text"
                  icon="el-icon-edit"
                  @click="enableTabEdit('settle')">
                  编辑
                </el-button>
                <el-button
                  v-if="settleEditable"
                  type="text"
                  icon="el-icon-plus"
                  @click="openSettlementDialog">
                  新增结算记录
                </el-button>
              </div>
            </div>
            <div class="tab-panel-surface">
              <SettleSetting
                ref="settleSetting"
                detail-mode
                :is-editor="settleEditable"
                :id="id"
                :data-form="dataForm" />
            </div>
          </el-card>
          <el-card v-else class="detail-card tab-panel-card" shadow="never">
            <div slot="header" class="detail-panel-header">
              <div>
                <h2>结算信息</h2>
                <p>维护红人结算方式和结算配置</p>
              </div>
            </div>
            <div class="tab-panel-surface empty-panel-surface">
              <div class="empty-state">暂无查看结算信息权限</div>
            </div>
          </el-card>
        </el-tab-pane>

        <el-tab-pane label="操作日志" name="logs">
          <el-card class="detail-card tab-panel-card logs-panel" shadow="never">
            <div slot="header" class="detail-panel-header">
              <div>
                <h2>操作日志</h2>
                <p>查看转组记录和签约信息操作日志</p>
              </div>
            </div>
            <div class="logs-table-wrap">
              <div class="logs-section-title">转组记录</div>
              <TransferRecord
                v-if="id && userPermissions.indexOf('sign_transfer_group') !== -1"
                detail-mode
                :artist-id="id" />
              <el-empty
                v-else
                description="暂无查看转组记录权限"
                :image-size="80" />
              <div class="logs-section-title logs-section-title--offset">操作日志</div>
              <ArtistLog v-if="id" detail-mode :artist-id="id" />
            </div>
          </el-card>
        </el-tab-pane>
      </el-tabs>
    </main>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AccountSourceSelect from '@/pages/sign_info/components/AccountSourceSelect.vue'
import ArtistLog from '@/pages/artist/ArtistLog.vue'
import BefPlatformInfo from '@/pages/sign_info/components/BefPlatformInfo.vue'
import SettleSetting from '@/pages/sign_info/components/SettleSetting.vue'
import SignatoryQuery from '@/pages/sign_info/components/SignatoryQuery.vue'
import SignRecordTable from '@/pages/sign_info/components/SignRecordTable.vue'
import TransferRecord from '@/pages/sign_info/components/TransferRecord.vue'
import { MapSignType } from '@/enum/sign-info'

export default {
  name: 'SignInfoModulesKoLDetail',
  components: {
    AccountSourceSelect,
    ArtistLog,
    BefPlatformInfo,
    SettleSetting,
    SignatoryQuery,
    SignRecordTable,
    TransferRecord
  },
  computed: {
    ...mapGetters(['userPermissions']),
    canEditSignInfo() {
      return this.userPermissions.indexOf('sign_enter_page') > -1
    },
    canViewIdCard() {
      return this.hasPermission('sign_view_id_card')
    },
    canViewRatio() {
      return this.hasPermission('sign_view_ratio')
    },
    canViewRemark() {
      return this.hasPermission('sign_view_remark') || this.hasPermission('sign_view_ratio')
    },
    baseEditable() {
      return this.editTab === 'base'
    },
    recordsEditable() {
      return this.editTab === 'records'
    },
    settleEditable() {
      return this.editTab === 'settle'
    },
    deadlineDays() {
      return this.getDeadlineDays(this.dataForm.sign_end)
    },
    deadlineTagText() {
      const days = this.deadlineDays
      if (days === null || this.isFired()) return ''
      if (days < 0) return `已过期 ${Math.abs(days)} 天`
      if (days === 0) return '今天到期'
      if (days <= 30) return `即将到期，剩余 ${days} 天`
      return `剩余 ${days} 天到期`
    },
    deadlineTagType() {
      const days = this.deadlineDays
      if (days === null) return ''
      if (days < 0) return 'info'
      if (days <= 30) return 'danger'
      if (days >= 180) return 'success'
      return 'warning'
    },
    natureText() {
      if (this.dataForm.nature_alias) return this.dataForm.nature_alias
      if (Number(this.dataForm.nature) === 1) return '全约'
      if (Number(this.dataForm.nature) === 2) return '商务约'
      return '-'
    },
    detailSummary() {
      return `签约人 ${this.displayValue(this.dataForm.signatory)} · 合约性质 ${this.natureText} · ${this.statusText()}`
    }
  },
  watch: {
    '$route'() {
      this.initForm()
    }
  },
  data() {
    return {
      MapSignType,
      activeTab: 'base',
      editTab: '',
      id: null,
      loadingSubmit: false,
      platformOptions: [],
      dataForm: {
        contract_no: '',
        sign_bef_info: []
      },
      rules: {
        nickname: [{ required: true, message: '请输入红人昵称', trigger: 'blur' }],
        sign_date: [{ required: true, message: '请选择签约日期', trigger: 'change' }],
        signatory: [{ required: true, message: '请输入签约人', trigger: 'blur' }],
        real_name: [{ required: true, message: '请输入红人姓名', trigger: 'blur' }],
        id_card: [{ required: true, message: '请输入身份证号', trigger: 'blur' }],
        tel: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
        address: [{ required: true, message: '请输入常用地址', trigger: 'blur' }],
        sign_type: [{ required: true, message: '请选择签约类型', trigger: 'change' }]
      },
      accountSourceOptions: [
        { label: '组内提供微信', val: 'pwg' },
        { label: '自己寻找', val: 'fys' }
      ]
    }
  },
  created() {
    this.getPlatforms()
  },
  mounted() {
    this.initForm()
  },
  methods: {
    async getPlatforms() {
      const { list } = await this.$api.getPlatforms()
      this.platformOptions = list
    },
    hasPermission(permissionName) {
      return this.userPermissions.indexOf(permissionName) > -1
    },
    initForm() {
      this.id = this.$route.params.id
      this.editTab = this.$route.query.isEditor === 'Y' ? 'base' : (this.$route.query.editTab || '')
      if (this.id) {
        this.getDetail()
      }
    },
    async getDetail() {
      const { info } = await this.$api.getKolSignInfo(this.id)
      this.dataForm = this.normalizeInfo(info || {})
    },
    normalizeInfo(info) {
      const data = { ...info }
      if (!Array.isArray(data.sign_bef_info)) {
        data.sign_bef_info = []
      }
      if (!data.wechat) {
        data.wechat = this.firstValue([
          data.wechat_id,
          data.wx,
          data.wx_id,
          data.weixin,
          data.weixin_id
        ], '')
      }
      if (!data.contract_no) {
        data.contract_no = this.firstValue([
          data.contract_number,
          data.contract_code,
          data.contract_id
        ], '')
      }
      const signDate = data.sign_date || data.sign_start
      if (signDate) {
        data.sign_date = signDate
        if (!data.year || !data.month) {
          const dateParts = String(signDate).split(/[-/]/)
          if (dateParts.length >= 2) {
            data.year = data.year || dateParts[0]
            data.month = data.month || Number(dateParts[1])
          }
        }
      }
      return data
    },
    backList() {
      this.$router.push({ name: 'sign_info' })
    },
    enableTabEdit(tabName) {
      this.activeTab = tabName
      this.editTab = tabName
      this.$router.replace({
        name: 'sign_detail',
        params: { id: this.id },
        query: { ...this.$route.query, editTab: tabName }
      })
    },
    openSignRecordDialog() {
      if (this.$refs.signRecordTable) {
        this.$refs.signRecordTable.handleAdd()
      }
    },
    openSettlementDialog() {
      if (this.$refs.settleSetting) {
        this.$refs.settleSetting.showSettlementDialog()
      }
    },
    saveTab(tabName) {
      if (tabName === 'base') {
        this.saveConfirm()
        return
      }
      this.exitTabEdit()
    },
    exitTabEdit() {
      this.editTab = ''
      const query = { ...this.$route.query }
      delete query.isEditor
      delete query.editTab
      this.$router.replace({ name: 'sign_detail', params: { id: this.id }, query })
    },
    saveConfirm() {
      if (!this.baseEditable) return
      this.$refs.refForm.validate((valid) => {
        if (valid) {
          this.formSubmit()
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    },
    async formSubmit() {
      this.loadingSubmit = true
      try {
        if (this.dataForm.id) {
          await this.$api.editSignInfo(this.dataForm)
        } else {
          await this.$api.addSignInfo(this.dataForm)
        }
        this.$message.success('保存成功')
        this.exitTabEdit()
        await this.getDetail()
      } finally {
        this.loadingSubmit = false
      }
    },
    changeSignDate(value) {
      const signDate = value || this.dataForm.sign_date
      if (signDate && String(signDate).indexOf('-') > -1) {
        const arr = String(signDate).split('-')
        this.$set(this.dataForm, 'year', arr[0])
        this.$set(this.dataForm, 'month', parseInt(arr[1]))
      }
    },
    getBefPlatformInfo(val) {
      this.$set(this.dataForm, 'sign_bef_info', val)
    },
    displayValue(value) {
      return value === null || value === undefined || value === '' ? '-' : value
    },
    firstValue(values, fallback = '-') {
      const value = values.find(item => item !== null && item !== undefined && item !== '')
      return value === null || value === undefined || value === '' ? fallback : value
    },
    parseDate(value) {
      if (!value) return null
      const date = new Date(String(value).replace(/\//g, '-'))
      if (isNaN(date.getTime())) return null
      date.setHours(0, 0, 0, 0)
      return date
    },
    getDeadlineDays(value) {
      const date = this.parseDate(value)
      if (!date) return null
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      return Math.ceil((date.getTime() - today.getTime()) / 86400000)
    },
    isFired() {
      const alias = this.dataForm.sign_status_alias || ''
      return this.dataForm.sign_status === 'N' || alias.indexOf('解约') > -1
    },
    statusText() {
      const alias = this.dataForm.sign_status_alias || ''
      if (alias) return alias
      if (this.isFired()) return '已解约'
      return '在约'
    }
  }
}
</script>

<style scoped lang="scss">
.kol-detail-page {
  height: 100%;
  max-height: calc(100vh - 116px);
  min-height: 0;
  padding: 14px 14px 86px;
  background: #f5f7fb;
  color: #172033;
  box-sizing: border-box;
  overflow-y: auto;
  overflow-x: hidden;
}

.detail-header {
  min-height: 104px;
  padding: 18px 22px;
  background: #ffffff;
  border: 1px solid #e7ebf2;
  border-radius: 8px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
}

.back-link {
  height: 24px;
  padding: 0;
  color: #667085;
  font-size: 13px;
  line-height: 24px;
}

.detail-title-main {
  min-width: 0;
}

.detail-title-tools {
  display: flex;
  align-items: center;
  gap: 12px;
}

.detail-kicker {
  height: 24px;
  padding: 0 10px;
  color: #ff3176;
  background: #fff0f6;
  border: 1px solid #ffd1e2;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  font-size: 12px;
  line-height: 24px;
}

.detail-title-main h1 {
  margin: 8px 0 4px;
  color: #172033;
  font-size: 24px;
  font-weight: 700;
  line-height: 32px;
  letter-spacing: 0;
}

.detail-title-main p {
  margin: 0;
  color: #7a8494;
  font-size: 13px;
  line-height: 20px;
}

.detail-header-side {
  display: flex;
  align-items: stretch;
  gap: 12px;
  flex: 0 0 auto;
}

.detail-status-card {
  min-width: 240px;
  padding: 12px 14px;
  background: #f8fafc;
  border: 1px solid #edf1f6;
  border-radius: 8px;
  box-sizing: border-box;
}

.detail-status-card span {
  color: #8a94a6;
  display: block;
  font-size: 12px;
  line-height: 18px;
}

.detail-status-card strong {
  margin-top: 4px;
  color: #263142;
  display: block;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
}

.detail-status-card .el-tag {
  margin-top: 8px;
}

.detail-main {
  width: 100%;
  min-width: 1080px;
  margin: 12px 0 0;
}

.detail-tabs {
  width: 100%;
}

.detail-tabs ::v-deep .el-tabs__header {
  padding: 0 18px;
  margin-bottom: 12px;
  background: #ffffff;
  border: 1px solid #e7ebf2;
  border-radius: 8px;
  box-sizing: border-box;
}

.detail-tabs ::v-deep .el-tabs__content {
  overflow: visible;
}

.detail-tabs ::v-deep .el-tab-pane {
  height: auto;
}

.detail-tabs ::v-deep .el-tabs__nav-wrap::after {
  display: none;
}

.detail-tabs ::v-deep .el-tabs__item {
  height: 46px;
  line-height: 46px;
  padding: 0 28px 0 0;
  color: #667085;
  font-size: 14px;
  font-weight: 600;
}

.detail-tabs ::v-deep .el-tabs__item.is-active {
  color: #ff2f73;
}

.detail-tabs ::v-deep .el-tabs__active-bar {
  height: 3px;
  background: #ff2f73;
}

.detail-card {
  height: auto;
  min-height: 0;
  background: #ffffff;
  border: 1px solid #e7ebf2;
  border-radius: 8px;
  box-sizing: border-box;
  overflow: hidden;
}

.detail-panel-header,
.tab-panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.detail-panel-header h2 {
  margin: 0;
  color: #172033;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
}

.detail-panel-header p {
  margin: 2px 0 0;
  color: #8a94a6;
  font-size: 12px;
  line-height: 18px;
}

.detail-panel-header ::v-deep .el-button--text {
  height: 32px;
  padding: 0 10px;
  color: #ff3176;
  background: #fff0f6;
  border: 1px solid #ffd1e2;
  border-radius: 4px;
  font-size: 13px;
}

.tab-panel-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.tab-panel-title {
  min-height: 22px;
  padding-left: 10px;
  border-left: 3px solid #ff2f73;
  color: #172033;
  font-size: 15px;
  line-height: 22px;
  font-weight: 700;
}

.tab-panel-surface {
  min-height: 0;
  padding: 14px;
  background: #ffffff;
  border: 1px solid #e7ebf2;
  border-radius: 8px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: visible;
}

.tab-panel-footer {
  position: fixed;
  right: 24px;
  bottom: 18px;
  left: 24px;
  z-index: 10;
  min-height: 54px;
  padding: 9px 18px;
  background: #ffffff;
  border: 1px solid #e7ebf2;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(16, 24, 40, 0.08);
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.tab-panel-footer .el-button {
  width: 128px;
}

.tab-panel-card ::v-deep .el-table th.el-table__cell,
.tab-panel-card ::v-deep .el-table td.el-table__cell {
  padding: 6px 0;
  border-color: #edf1f6;
}

.tab-panel-card ::v-deep .el-table th.el-table__cell {
  color: #475467;
  background: #f8fafc;
  font-weight: 600;
}

.tab-panel-card ::v-deep .el-table .cell {
  line-height: 20px;
}

.logs-table-wrap {
  flex: 1;
  min-height: 0;
  width: 100%;
  margin: 0;
  padding: 14px;
  background: #ffffff;
  border: 1px solid #e7ebf2;
  border-radius: 8px;
  box-sizing: border-box;
  overflow-y: auto;
  overflow-x: hidden;
}

.logs-section-title {
  min-height: 38px;
  margin-bottom: 10px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: #172033;
  background: #f8fafc;
  border: 1px solid #edf1f6;
  border-radius: 6px;
  box-sizing: border-box;
  font-size: 14px;
  font-weight: 700;
}

.logs-section-title--offset {
  margin-top: 18px;
}

.detail-card ::v-deep .el-card__header {
  min-height: 62px;
  padding: 13px 18px;
  border-bottom: 1px solid #edf1f6;
  background: #ffffff;
  box-sizing: border-box;
}

.detail-card ::v-deep .el-card__body {
  height: auto;
  padding: 14px;
  background: #f5f7fb;
  box-sizing: border-box;
  overflow: visible;
}

.tab-panel-card ::v-deep .el-card__body {
  min-height: 0;
  height: auto;
  display: flex;
  flex-direction: column;
  padding: 14px;
  background: #f5f7fb;
  box-sizing: border-box;
  overflow: visible;
}

.base-detail-card {
  background: #ffffff;
}

.base-detail-card ::v-deep .el-card__body {
  padding: 14px;
  background: #f5f7fb;
}

.base-detail-layout-row {
  min-width: 0;
}

.base-detail-left,
.base-detail-right {
  min-width: 0;
}

.card-title {
  color: #001327;
  font-weight: 800;
}

.form-section {
  margin-top: 6px;
}

.base-detail-card .form-section {
  margin-top: 0;
  padding: 14px 16px 4px;
  background: #ffffff;
  border: 1px solid #e7ebf2;
  border-radius: 8px;
  box-sizing: border-box;
}

.form-section h3 {
  margin: 0 0 14px;
  padding-bottom: 10px;
  color: #172033;
  border-bottom: 1px solid #edf1f6;
  font-size: 15px;
  font-weight: 700;
  line-height: 22px;
}

.sign-section {
  margin-top: 12px;
}

.detail-info-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 16px;
  row-gap: 0;
}

.detail-info-grid::before,
.detail-info-grid::after {
  display: none;
}

.detail-info-grid > .el-col {
  width: auto !important;
  float: none;
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.detail-sign-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  column-gap: 16px;
  row-gap: 0;
}

.detail-sign-grid::before,
.detail-sign-grid::after {
  display: none;
}

.detail-sign-grid > .el-col {
  width: auto !important;
  float: none;
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.detail-sign-grid > .el-col-24 {
  grid-column: 1 / -1;
}

.detail-form ::v-deep .el-form-item {
  margin-bottom: 10px;
}

.detail-form ::v-deep .el-form-item__label {
  padding-bottom: 4px;
  color: #667085;
  font-weight: 600;
  line-height: 18px;
}

.detail-form ::v-deep .el-input,
.detail-form ::v-deep .el-select,
.detail-form ::v-deep .el-date-editor,
.detail-form ::v-deep .el-autocomplete,
.detail-form ::v-deep .signatory-query {
  width: 100%;
}

.detail-form ::v-deep .el-input:not(.is-disabled) .el-input__inner,
.detail-form ::v-deep .el-textarea:not(.is-disabled) .el-textarea__inner {
  border-color: #d9e0ea;
  border-radius: 4px;
  color: #263142;
  font-weight: 400;
}

.detail-form ::v-deep .el-input.is-disabled .el-input__inner,
.detail-form ::v-deep .el-textarea.is-disabled .el-textarea__inner {
  color: #475467;
  -webkit-text-fill-color: #475467;
  background-color: #f8fafc;
  border-color: #d9e0ea;
  cursor: default;
}

.platform-section {
  padding-top: 32px;
}

.base-detail-card .platform-section {
  min-height: 100%;
  padding-top: 14px;
}

.platform-section ::v-deep .sign-bef {
  padding: 0;
  margin: 0;
  border: 0;
}

.platform-section ::v-deep .sign-bef > div:first-child {
  gap: 10px !important;
}

.platform-section ::v-deep .el-table {
  width: 100% !important;
}

.detail-actions {
  position: fixed;
  right: 24px;
  bottom: 18px;
  left: 24px;
  z-index: 10;
  min-height: 54px;
  padding: 9px 18px;
  background: #ffffff;
  border: 1px solid #e7ebf2;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(16, 24, 40, 0.08);
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.detail-actions .el-button {
  width: 128px;
}

.empty-state {
  height: 260px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #909399;
}

.logs-panel ::v-deep .el-card__body {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.logs-panel .logs-table-wrap {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
